import * as Yup from 'yup';

export const AddMenuSchema = Yup.object({
  showMenu: Yup.boolean(),
  title: Yup.string()
    .min(1, 'At least 1 characters or more')
    .required('Please enter a menu name'),
});
